import React from "react";

const HotelTravelDesk = () => {
  return (
    <>
      {/* ===== BREADCRUMB ===== */}
<section
        className="breadcrumb-section"
        style={{
          backgroundImage:
            "url(/images/background/inner-banner-bg.jpg)",
        }}
      >
        <div className="container">
          <div className="banner-content text-center">
            <h1>Hotel Travel Desk</h1>
          </div>
        </div>
      </section>


   

      {/* ===== MAIN CONTENT SECTION ===== */}
      <section className="py-5 bg-white">
        <div className="container">
          <div className="row align-items-center">

            {/* IMAGE */}
            <div className="col-lg-6 mb-4 mb-lg-0">
              <img
                src="/images/gallery/07.jpeg"
                alt="Hotel Travel Desk Services in Pune"
                className="img-fluid rounded shadow-lg"
              />
            </div>

            {/* CONTENT */}
            <div className="col-lg-6">
              <h2 className="mb-3">
                <span className="text-danger">Hotel</span> Travel Desk Services
              </h2>

              <p>
                Pune Corporate Cars India Pvt. Ltd. offers professional
                hotel travel desk management services designed to enhance
                guest experience and support hotel operations seamlessly.
              </p>

              <p>
                We act as an extension of your hotel’s front office by
                providing reliable transportation solutions for business
                travelers, tourists, corporate guests, and VIP visitors.
              </p>

              <p>
                From airport pickups and local transfers to outstation
                travel and customized sightseeing tours, our trained
                chauffeurs and premium fleet ensure safe, comfortable,
                and punctual journeys for every guest.
              </p>
            </div>

          </div>
        </div>
      </section>

      {/* ===== WHY CHOOSE US ===== */}
      <section className="py-5 bg-light">
        <div className="container">

          <div className="row mb-4">
            <div className="col-12 text-center">
              <h2 className="mb-3">Why Choose Our Hotel Travel Desk?</h2>
              <p className="text-muted">
                A trusted mobility partner for hotels, serviced apartments,
                and hospitality brands.
              </p>
            </div>
          </div>

          <div className="row">

            <div className="col-md-6 mb-4">
              <ul className="list-unstyled">
                <li className="mb-3">✔ Dedicated on-site or off-site travel desk</li>
                <li className="mb-3">✔ Airport pickup & drop services</li>
                <li className="mb-3">✔ Local, outstation & sightseeing tours</li>
                <li className="mb-3">✔ Trained, uniformed chauffeurs</li>
              </ul>
            </div>

            <div className="col-md-6 mb-4">
              <ul className="list-unstyled">
                <li className="mb-3">✔ Premium sedans, SUVs & luxury cars</li>
                <li className="mb-3">✔ 24×7 booking & guest support</li>
                <li className="mb-3">✔ Transparent billing & MIS reports</li>
                <li className="mb-3">✔ Enhanced guest satisfaction & reviews</li>
              </ul>
            </div>

          </div>

        </div>
      </section>
    </>
  );
};

export default HotelTravelDesk;
